import { render } from "./SchedulerPage.vue?vue&type=template&id=1271a363&scoped=true"
import script from "./SchedulerPage.vue?vue&type=script&lang=js"
export * from "./SchedulerPage.vue?vue&type=script&lang=js"

import "./SchedulerPage.vue?vue&type=style&index=0&id=1271a363&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1271a363"]])

export default __exports__